export default __webpack_public_path__ + "static/Artificial_Light_Outdoor_2560kbps-661b0e3f0bb4418cc01a30e49f5812ea.avif";